import { useEffect } from "react";
type TruspilotProps = {
    // Essentials : boolean,
    testimonials : boolean,
}
export default function TrustPilotCustom({testimonials}:TruspilotProps) 
{
    //In this component you can enter two types of trust pilot custom, and depending on the variable return them.
    //The use effect, works with the class of the div, to load the javascript and then the trust pilot.
    //First ID div in Header
    //Second Id div in Footer
    useEffect(()=>{
        try {
            if(testimonials) {
                var trustbox = document.getElementsByClassName(`Here is the first class`);
                for (let i=0; i<= trustbox.length; i++)
                {
                    window.Trustpilot.loadFromElement(trustbox.item(i)); 
                }
            }
            else{
                var trustbox = document.getElementsByClassName(`Here is the second class`);
                for (let i=0; i<= trustbox.length; i++)
                {
                    window.Trustpilot.loadFromElement(trustbox.item(i)); 
                }
            }
           
              
        } catch (error) {
            console.error("loading trustpilot")
        }
      },[])
    
    return (
        <>
        {testimonials  ?
            <div className="`Here is the first class`">
            </div>
            :
            <div className="`Here is the second class`">
            </div>
        }
        </>
    );
}